import { TEXT_PROPS } from './default-props';

// Mood Board Color
export const BG_PRIMARY = '#fff7ed';
export const BG_SECONDARY = '#FFF';
export const BG_ALTERNATIVE = '#caad90';
export const BG_LAYER = 'rgba(255, 247, 237, 0.7)';

// Text Color
export const TEXT_PRIMARY = '#473c31'; //black
export const TEXT_SECONDARY = '#977a5e'; //dark brown
export const TEXT_ALTERNATIVE = '#b3916f'; //light brown

export const ASSET_COLOR = TEXT_SECONDARY;

// Music & Navigation Color
export const NAVIGATION_COLOR = TEXT_PRIMARY;
export const ICON_NAVIGATION_COLOR = 'white';

// Default Button Color
export const BUTTON_PROPS = {
  _hover: { opacity: '.8' },
};

export const BUTTON_PADDING_PROPS = {
  ...TEXT_PROPS.body,
  variant: 'solid',
  padding: '18px 22px',
  borderRadius: '18px',
  background: `linear-gradient(to right, ${TEXT_ALTERNATIVE}, ${BG_ALTERNATIVE})`,
  color: BG_PRIMARY,
  size: 'sm',
  boxShadow: 'sm',
  fontSize: '14px',
  position: 'relative',
  fontStyle: 'normal',
  zIndex: '20',
  minWidth: "120px",
  letterSpacing: "normal",
  _hover: {
    opacity: '.9',
  },
};

export const DEFAULT_BUTTON_PROPS = {
  fontWeight: 'normal',
};
